export const
    DEFAULT = "DEFAULT",
    START_DRAG = "START_DRAG",
    STOP_DRAG = "STOP_DRAG",
    SET_SELECTED_ELEMENT = "SET_SELECTED_ELEMENT",
    UPDATE_PROPERTY = "UPDATE_PROPERTY",
    START_RESIZE = "START_RESIZE",
    CREATE_DEFAULT_THEME = "CREATE_DEFAULT_THEME",
    UPDATE_ORDER_PROPERTY = "UPDATE_ORDER_PROPERTY",
    ADD_ELEMENT = "ADD_ELEMENT",
    REMOVE_PAGE_ELEMENT = "REMOVE_PAGE_ELEMENT",
    SET_CURRENT_PAGE = "SET_CURRENT_PAGE",
    CREATE_COMPOSITION_AND_SET_EDITING = "CREATE_COMPOSITION_AND_SET_EDITING",
    ADD_COMPOSITION_ELEMENT = "ADD_COMPOSITION_ELEMENT",
    START_RESIZE_COMPOSITION = "START_RESIZE_COMPOSITION",
    START_DRAG_COMPOSITION = "START_DRAG_COMPOSITION",
    REMOVE_COMPOSITION_ELEMENT = "REMOVE_COMPOSITION_ELEMENT",
    SET_SELECTED_COMPOSITION_ELEMENT = "SET_SELECTED_COMPOSITION_ELEMENT",
    GET_RESSOURCES = "GET_RESSOURCES",
    UPLOAD_COMPOSITION = "UPLOAD_COMPOSITION",
    GET_COMPOSITIONS = "GET_COMPOSITIONS",
    REMOVE_COMPOSITION = "REMOVE_COMPOSITION",
    UPLOAD_RESSOURCE = "UPLOAD_RESSOURCE",
    REMOVE_RESSOURCE = "REMOVE_RESSOURCE",
    SET_FONT_FAMILY = "SET_FONT_FAMILY",
    UPLOAD_THEME = "UPLOAD_THEME",
    GET_THEMES = "GET_THEMES",
    EXPORT_FULL_THEME = "EXPORT_FULL_THEME",
    DELETE_THEME = "DELETE_THEME",
    DUPLICATE_THEME = "DUPLICATE_THEME",
    DUPLICATE_COMPOSITION = "DUPLICATE_COMPOSITION",
    SELECT_THEME = "SELECT_THEME"

